// BackupCenter.js

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";

const BackupCenter = () => {
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [backupData, setBackupData] = useState({});
  const [backupRunning, setBackupRunning] = useState(false);
  const [intervalId, setIntervalId] = useState(null);
  const serverURL = process.env.REACT_APP_SERVER_BASE_URL;

  const handleDateChange = (setter) => (date) => {
    setter(date);
  };

  const fetchLatestBackup = async () => {
    try {
      const response = await axios.get(`${serverURL}/getBackup`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('access_token')}` }
      });
      const latestBackup = response.data;
      setBackupData(latestBackup);
      return latestBackup;
    } catch (error) {
      console.error('Error fetching latest backup:', error);
      setBackupData({ backup_status: 'Error fetching latest backup' });
    }
  };

  const handleRunBackup = async () => {
    setBackupRunning(true);
    setBackupData({ backup_status: 'Backup started...' });

    // Start the interval for checking the status
    const id = setInterval(async () => {
      const latestBackup = await fetchLatestBackup(); // Fetch latest backup data

      // Check if the backup status indicates completion or failure
      if (latestBackup && (latestBackup.backup_status === 'complete' || latestBackup.backup_status === 'fail')) {
        clearInterval(id);
        setBackupRunning(false);
      }
    }, 20000); // Check every 20 seconds
    setIntervalId(id);

    // Call the backupData API without waiting for it to complete
    axios.get(`${serverURL}/backupData`, {
      params: { date_start: startDate.toISOString().split('T')[0], date_end: endDate.toISOString().split('T')[0] },
      headers: { Authorization: `Bearer ${localStorage.getItem('access_token')}` }
    }).catch(error => {
      console.error('Error running backup:', error);
      setBackupData({ backup_status: 'Backup failed' });
      clearInterval(id); // Clear interval on error
      setBackupRunning(false);
    });
  };

  // Cleanup interval on component unmount
  useEffect(() => {
    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [intervalId]);

  useEffect(() => {
    fetchLatestBackup();
  }, []);

  return (
    <div className="backup-component" style={{ border: '1px solid black', padding: '30px' }}>
      <div><h3>Backup Status</h3></div>
      <div>
        <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '20px' }}>
          <thead>
            <tr>
              <th style={{ border: '1px solid black', padding: '8px' }}>Backup ID</th>
              <th style={{ border: '1px solid black', padding: '8px' }}>From</th>
              <th style={{ border: '1px solid black', padding: '8px' }}>To</th>
              <th style={{ border: '1px solid black', padding: '8px' }}>Status</th>
              <th style={{ border: '1px solid black', padding: '8px' }}>Invoices Processed</th>
              <th style={{ border: '1px solid black', padding: '8px' }}>Receipts Processed</th>
              <th style={{ border: '1px solid black', padding: '8px' }}>Processing Time (mins)</th>
              <th style={{ border: '1px solid black', padding: '8px' }}>Error Details</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={{ border: '1px solid black', padding: '8px' }}>{backupData.backup_id || 'N/A'}</td>
              <td style={{ border: '1px solid black', padding: '8px' }}>{backupData.backup_from || 'N/A'}</td>
              <td style={{ border: '1px solid black', padding: '8px' }}>{backupData.backup_to || 'N/A'}</td>
              <td style={{ border: '1px solid black', padding: '8px' }}>{backupData.backup_status || 'N/A'}</td>
              <td style={{ border: '1px solid black', padding: '8px' }}>{backupData.total_invoice_processed || 'N/A'}</td>
              <td style={{ border: '1px solid black', padding: '8px' }}>{backupData.total_receipts_processed || 'N/A'}</td>
              <td style={{ border: '1px solid black', padding: '8px' }}>{backupData.total_processing_minutes || 'N/A'}</td>
              <td style={{ border: '1px solid black', padding: '8px' }}>{backupData.backup_error_detail || 'None'}</td>
            </tr>
            <tr>
                <td colSpan='8' style={{ border: '1px solid black', padding: '8px' }}>Backup data goes as far back as: {backupData.backup_min_validity} and as forward as: {backupData.backup_max_validity}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div>
        <label htmlFor="start-date">Start Date:</label>
        <DatePicker
          selected={startDate}
          onChange={handleDateChange(setStartDate)}
          dateFormat="yyyy-MM-dd"
          id="start-date"
        />
      </div>
      <div>
        <label htmlFor="end-date">End Date:</label>
        <DatePicker
          selected={endDate}
          onChange={handleDateChange(setEndDate)}
          dateFormat="yyyy-MM-dd"
          id="end-date"
        />
      </div>
      <div>
        <button onClick={handleRunBackup} disabled={backupRunning}>Run Backup</button>
      </div>
    </div>
  );
};

export default BackupCenter;
